const VERSION = "13.2.6";
export {
  VERSION
};
//# sourceMappingURL=version.js.map
